import { useCallback, useEffect, useState } from 'react'

/** Keep account-day rendering pure while aligning timers with the server clock. */
export function useAccountDayClock(serverNow?: string) {
  const [localNowMs, setLocalNowMs] = useState(Date.now)
  const [offsetMs, setOffsetMs] = useState(0)

  useEffect(() => {
    const nowMs = Date.now()
    const serverNowMs = Date.parse(serverNow ?? '')
    setLocalNowMs(nowMs)
    setOffsetMs(Number.isFinite(serverNowMs) ? serverNowMs - nowMs : 0)
  }, [serverNow])

  const refresh = useCallback(() => { setLocalNowMs(Date.now()) }, [])
  // This imperative read belongs only in event handlers and effects. Rendering
  // uses the state snapshot below, so unrelated renders cannot change the date.
  const currentTime = useCallback(() => Date.now() + offsetMs, [offsetMs])

  return { nowMs: localNowMs + offsetMs, currentTime, refresh }
}
